import { render, staticRenderFns } from "./RevisionLayoutCollapse.vue?vue&type=template&id=787059aa"
import script from "./RevisionLayoutCollapse.vue?vue&type=script&lang=js"
export * from "./RevisionLayoutCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports